import styled from "styled-components";
import { mobile, tablet } from "../responsive";

const Image = styled.img`
    object-fit: cover;
    width: 100%;
    height: 100%;
    opacity: 0.75;
    display: block;
`;

const Header = styled.div`
    height: 42vh;
    width: 100%;
    background: var(--brand-black);
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid var(--brand-rule);
    ${mobile({ height: "32vh" })}
    ${tablet({ height: "40vh" })}

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
            to top,
            var(--brand-black) 0%,
            rgba(10, 10, 10, 0.35) 45%,
            rgba(10, 10, 10, 0.2) 100%
        );
        pointer-events: none;
    }
`;

const Title = styled.h1`
    text-transform: uppercase;
    padding: 0 1rem;
    font-family: "FuturaPT-Bold", sans-serif;
    font-size: 3rem;
    margin: 0;
    color: var(--brand-white);
    letter-spacing: 0.08em;
    text-align: center;
    ${mobile({ fontSize: "1.75rem" })}
    ${tablet({ fontSize: "2.25rem" })}
`;

const Section = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--brand-white);
    z-index: 1;
    width: 90%;
`;

const BannerOverlay = ({ imageUrl, title }) => {
    const hasTitle = Boolean(title && String(title).trim());

    return (
        <Header>
            <Image src={imageUrl} alt={hasTitle ? title : "Banner"} />
            {hasTitle && (
                <Section>
                    <Title>{title}</Title>
                </Section>
            )}
        </Header>
    );
};

export default BannerOverlay;
